module.exports = {
          srcSet: "/_next/static/images/img-vetements@2x-160-9f0aff0980067a5781bbef2c94f245a5.jpg"+" 160w"+","+"/_next/static/images/img-vetements@2x-292-29798a275730b81d3ac0abc69a9e04d1.jpg"+" 292w",
          images:[ {path: "/_next/static/images/img-vetements@2x-160-9f0aff0980067a5781bbef2c94f245a5.jpg",width: 160,height: 137},{path: "/_next/static/images/img-vetements@2x-292-29798a275730b81d3ac0abc69a9e04d1.jpg",width: 292,height: 250}],
          src: "/_next/static/images/img-vetements@2x-160-9f0aff0980067a5781bbef2c94f245a5.jpg",
          toString:function(){return "/_next/static/images/img-vetements@2x-160-9f0aff0980067a5781bbef2c94f245a5.jpg"},
          placeholder: undefined,
          width: 160,
          height: 137
      }